import React, {memo, useEffect} from "react";
import {Modal, ModalBody, ModalHeader, Table} from "reactstrap";
import PropTypes from "prop-types";
import {useDispatch, useSelector} from "react-redux";
import {getSensorSummary} from "../../redux/Selectors/controllers.selectors";
import {
  requestSensorSummary,
  requestSensorSummaryReset,
} from "../../redux/Actions/controllers.actions";
import {get} from "lodash";
import humanizeString from "string-humanize";
import Tooltip from "../Tooltip/Tooltip";

const SensorSummaryModal = (props) => {
  const dispatch = useDispatch();
  const sensorSummary = useSelector(getSensorSummary);

  useEffect(() => {
    dispatch(requestSensorSummary(props.sensorId));
  }, [dispatch, props.sensorId]);

  const emptySelector = () => {
    dispatch(requestSensorSummaryReset());
  };

  return (
    <>
      <Modal
        unmountOnClose={true}
        isOpen={props.open}
        toggle={props.toggle}
        onAbort={emptySelector}
        onError={emptySelector}
        onExit={emptySelector}
      >
        <ModalHeader toggle={props.toggle}>Summary</ModalHeader>
        <ModalBody style={{padding: 0}}>
          <Table className="card-body">
            <tbody>
              {sensorSummary && (
                <>
                  <tr>
                    <td>Description</td>
                    <td id={"sensorSummary--title"}>{sensorSummary.title}</td>
                    <Tooltip target={"sensorSummary--title"} />
                  </tr>
                  <tr>
                    <td>Added By</td>
                    <td id={"sensorSummary--created_by"}>{sensorSummary.created_by}</td>
                    <Tooltip target={"sensorSummary--created_by"} />
                  </tr>
                  <tr>
                    <td>Added On</td>
                    <td id={"sensorSummary--created_at"}>{sensorSummary.created_at}</td>
                    <Tooltip target={"sensorSummary--created_at"} />
                  </tr>
                  <tr>
                    <td>In Service Since</td>
                    <td id={"sensorSummary--service_days"}>
                      {sensorSummary.service_days}
                    </td>
                    <Tooltip target={"sensorSummary--service_days"} />
                  </tr>
                  {get(sensorSummary, "additional") &&
                    Object.entries(sensorSummary.additional).map((eachField, index) => (
                      <>
                        <tr>
                          <td>{humanizeString(eachField[0])}</td>
                          <td id={`additional-${index}`}>{eachField[1]}</td>
                          <Tooltip target={`additional-${index}`} />
                        </tr>
                      </>
                    ))}
                </>
              )}
            </tbody>
          </Table>
        </ModalBody>
      </Modal>
    </>
  );
};

function areEqual(prevProps, nextProps) {
  return prevProps.open === nextProps.open;
}

SensorSummaryModal.propTypes = {
  open: PropTypes.bool,
  toggle: PropTypes.func,
  sensorId: PropTypes.number.isRequired,
};
export default memo(SensorSummaryModal, areEqual);
